<template>
    <div id="forgot-password" class="container-fluid">
        <div class="row align-items-center justify-content-center">
            <div class="col-sm-6">
                <h1>Forgot Password</h1>

                <form @submit.prevent="requestReset" class="form" v-if="status != 'success'">
                    <p class="mb-4">If you have forgotten your password, enter your email address below and an email with instructions will be sent to you.</p>
                    <b-form-group>
                        <b-form-input v-model.trim="$v.authData.email.$model" :class="{ 'is-invalid': $v.authData.email.$error }" placeholder="Enter your email address"></b-form-input>
                        <div class="invalid-feedback" v-if="$v.authData.email.$error">Please enter a valid email address</div>
                    </b-form-group>
                    
                    <div class="alert alert-danger" v-if="status == 'error'">{{ statusMessage }}</div>
                    
                    <SubmitButton title="Send Reset Email" :is-disabled="$v.$invalid || !$v.$anyDirty" :is-saving="isSaving" class="mr-3" /> Did you remember? <better-link :to="{path: '/login'}">Log In</better-link>
                </form>
                
                <div class="alert alert-success" v-else>{{ statusMessage }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import SubmitButton from '@/components/form-controls/SubmitButton'

import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'
import email from 'vuelidate/lib/validators/email'

export default {
    name: 'ForgotPassword',
    mixins: [
        validationMixin
    ],
    components: {
        SubmitButton,
    },
    head: {
        title() {
            return {
                inner: 'Forgot Password',
            }
        },
    },
    validations: {
        authData: {
            email: {
                required,
                email,
            },
        },
    },
    data() {
        return {
            authData: {
                email: this.$route.query.email || '',
            },
            isSaving: false,
            status: '',
            statusMessage: '',
        }
    },
    methods: {
        requestReset() {
            this.status = ''
            this.isSaving = true
            axios({
                url: process.env.VUE_APP_API_BASE_URL + '/password/forgot',
                method: 'POST',
                data: {
                    ...this.authData,
                },
            }).then(response => {
                this.isSaving = false
                this.status = 'success'
                this.statusMessage = response.data.message
            }).catch(error => {
                this.isSaving = false
                this.status = 'error'
                this.statusMessage = error.response.data.message
            })
        },
    },
    mounted() {
        if (this.authData.email != '') {
            this.$v.authData.email.$touch()
        }
    },
    activated() {
        this.$emit('updateHead')
    },
};
</script>